import { useState, useCallback } from 'react';
import { DeleteIcon, Plus } from 'assets/icons';
import * as S from './PackageNameInput.styled';
import { CustomInput, IconButton } from 'components';
import { cloneDeep } from 'lodash-es';
import { v4 as uuidv4 } from 'uuid';

const PackageNameInput = ({ selectedPackageNames, setSelectedPackageName }) => {
  const [text, setText] = useState('');

  const checkUniqueNames = (text) => {
    const uniqueNameIndex = selectedPackageNames.findIndex((name) => name.package_id === text);
    if (!text) return false;
    if (uniqueNameIndex === -1) return false;
    return true;
  };

  const handleInput = useCallback((e) => {
    setText(e.target.value);
  }, []);

  const handleDeleteItem = useCallback(() => {
    setText('');
  }, []);

  const handleAddPackage = useCallback(() => {
    if (!checkUniqueNames(text)) {
      const newItem = {
        package_id: text,
        id: uuidv4(),
      };
      let newData = cloneDeep(selectedPackageNames);
      newData.push(newItem);
      setSelectedPackageName(newData);
      handleDeleteItem();
    }
  }, [text]);

  return (
    <S.InputWrapper>
      <CustomInput
        placeholder='Enter the Package Name'
        name='exclude_package_name'
        id='exclude_package_name'
        value={text}
        error={checkUniqueNames(text)}
        errorText='Name should be unique.'
        onChange={handleInput}
        rightIconOnClick={handleDeleteItem}
        rightIcon={
          text ? (
            <S.IconWrapp>
              <DeleteIcon />
            </S.IconWrapp>
          ) : null
        }
      />
      <IconButton.NormalSize
        icon={Plus}
        disabled={!text}
        type={IconButton.btnTypes.secondary}
        onClick={handleAddPackage}
        style={{ width: '50px' }}
      />
    </S.InputWrapper>
  );
};

export default PackageNameInput;
